export default __webpack_public_path__ + "static/media/dljd.b7615ce7.png";